import React from 'react';
const Page =() => (<div></div>)
export default Page